module.exports = __webpack_public_path__ + "static/metaverse-3e9c5d6088a86ff7025528442322bcb2.webp";